import { Input } from 'ccs-ui-components';
import { Col, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { SERVICE_DETAILS_MAXLENGTH, SERVICE_TYPE_KEY_VALUE } from '../../../../../constants';
import { IServiceDetailsValidationModel } from '../../../../../models';
import { getServiceEndPointLabel, getServiceEndPointPlaceholder } from '../../../../../utilities/services/LabelUtils';
import { ServiceVariableTooltip } from '../../../../../utilities/services/ServiceVariableTooltip';

interface IServiceEndpointProps {
  serviceTypeValue: string | undefined
  formData: IServiceDetailsValidationModel;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isViewMode: boolean
}
const ServiceEndpoint = ({
  formData,
  handleInputChange,
  serviceTypeValue,
  isViewMode
}: IServiceEndpointProps) => {
  const { t: translate } = useTranslation();
  return (
    <Col md={6}>
      <Form.Group className="mb-3" controlId="formServiceEndpoint">
        <Input
          isMandatory={serviceTypeValue !== `${SERVICE_TYPE_KEY_VALUE.EXTERNAL}`}
          labelText={getServiceEndPointLabel(serviceTypeValue ?? '0', translate)}
          infoIconTxt={<ServiceVariableTooltip />}
          placeholder={String(translate('service_details_form_component.plchd_service_endpoint_host'))}
          type="text"
          name="endpoint"
          data-testid="service-endpoint-input"
          value={formData.endpoint.value}
          onChange={handleInputChange}
          // placeholder={String(getServiceEndPointPlaceholder(serviceTypeValue ?? '0', translate))}
          label=""
          errorTxt={!isViewMode ? formData.endpoint.error : ''}
          error={!formData.endpoint.isValid && !isViewMode}
          maxLength={Number(SERVICE_DETAILS_MAXLENGTH.endPointMaxLength)}
        />
      </Form.Group>
    </Col>
  );
};

export default ServiceEndpoint;
